import React, { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web"

const PrivateRouteElement = ({children}) => {
	const { keycloak, initialized } = useKeycloak();

	useEffect(() => {
		if (initialized) {
		  if (!keycloak.authenticated) {
			keycloak.login();
		  }
		}
	}, [initialized]);
	
	if (!initialized) {
		return <p>Loading...</p>;
	}

	if (!keycloak.authenticated) {
		return <p>Authenticating...</p>;
	}
	
	return children;
}

export default PrivateRouteElement;